import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import * as yup from 'yup';

import { Dropdown, AttentionBox, Checkbox, Dialog, DialogContentContainer, IconButton, Link } from "monday-ui-react-core";
import { Info } from "monday-ui-react-core/dist/allIcons";

import Monday from "../../auth/useMonday.jsx";
import Loader from "../../libs/loader.jsx";

import Notification from "../../libs/notification.jsx";

class Share extends React.Component
{
    constructor(props)
    {
        super(props);
        
        this.state = {
            'shares': this.props.shares,
            'user_options': [],
            'user_selected': [],
            'team_options': [],
            'team_selected': [],
            'users': {},
            'teams': {},
        };
        
        this.loader = React.createRef();
        this.synStateTimer = false;
    }
    
    async promisedSetState(newState)
    { 
        var state = this.state;
        for(let key of Object.keys(newState))
        {
            state[key] = newState[key];
        }
        
        this.state = state;
        
        var this_component = this;
        if(this.synStateTimer==false)
        {
            this.synStateTimer = setTimeout( () => { 
                this_component.setState( {...this_component.state} );
                this_component.synStateTimer = false; 
            }, 100);
        }
        
        return true;
    }
    
    async loadUsers()
    {
        var users = await Monday.getUsers(this.loader);
        //console.log("loadUsers", users);
        
        await this.promisedSetState({'users': users});
        await this.createUserOptions();
    }
    
    async loadTeams()
    {
        var teams = await Monday.getTeams(this.loader);
        //console.log("loadTeams", teams);
        
        await this.promisedSetState({'teams': teams});
        await this.createTeamOptions();
    }
    
    async createUserOptions()
    {
        var this_component = this;
        var options = [];
        
        Object.keys(this_component.state.users).forEach(function(key, index) {
            var user = this_component.state.users[key];

            //skip inactive accounts
            if(user.enabled===false) return 0;

            options.push({'label': user.name,'value': parseInt(user.id)});
        });
        
        await this_component.promisedSetState({'user_options': options});
    }
    
    async createTeamOptions()
    {
        var this_component = this;
        var options = [];
        
        Object.keys(this_component.state.teams).forEach(function(key, index) {
            var team = this_component.state.teams[key];

            options.push({'label': team.name,'value': parseInt(team.id)});
        });
        
        await this_component.promisedSetState({'team_options': options});
    }
    
    async handleChangeUser(selected)
    {
        var this_component = this;
        
        var shares = this_component.state.shares;
        
        shares.users = [];
        
        //console.log('handleChangeUser', selected);
        //await this_component.promisedSetState({'user_selected': selected});
        
        if(selected!=null)
        {
            selected.map( (user) => {
               shares.users.push(user.value);
            });
        }
        
        await this_component.updateShares(shares);
        await this_component.updateSelected();
    }
    
    async handleChangeTeam(selected)
    {
        var this_component = this;
        
        var shares = this_component.state.shares;
        
        shares.teams = [];
        
        //console.log('handleChangeTeam', selected);
        //await this_component.promisedSetState({'team_selected': selected});
        
        if(selected!=null)
        {
            selected.map( (team) => {
               shares.teams.push(team.value);
            });
        }
        
        await this_component.updateShares(shares);
        await this_component.updateSelected();
    }
    
    async updateShares(shares)
    {
        var this_component = this;
        
        if(this_component.props.onUpdate != undefined)
        {
            this_component.props.onUpdate(shares);
            return false;
        }
        else
        {
            await this_component.promisedSetState( {'shares': {...shares} } );
            return true;
        }
    }
    
    async updateSelected()
    {
        var user_selected=[];
        var team_selected=[];
        var this_component = this;
        
        if( ('users' in this_component.state.shares) )
        {
            this_component.state.shares.users.map( (user_id) => {
                Object.keys(this_component.state.users).forEach(function(key, index) {
                    var user = this_component.state.users[key];
                    if(user.id==user_id) {
                        user_selected.push( {'label': user.name,'value': parseInt(user.id)} );
                    }
                });
            });
            await this_component.promisedSetState({'user_selected': [...user_selected]});
        }
        
        if( ('teams' in this_component.state.shares) )
        {
            this_component.state.shares.teams.map( (team_id) => {
                Object.keys(this_component.state.teams).forEach(function(key, index) {
                    var team = this_component.state.teams[key];
                    if(team.id==team_id) {
                        team_selected.push( {'label': team.name,'value': parseInt(team.id)} );
                    }
                });
            });
            await this_component.promisedSetState({'team_selected': [...team_selected]});
        }
    }
    
    async loadData()
    {
        var this_component = this;
        //console.log('share loadData');
        
        if(this_component.loader && ('current' in this_component.loader) && this_component.loader.current!=null) this_component.loader.current.showLoader();
        
        await this_component.loadUsers();
        await this_component.loadTeams();
        await this_component.updateSelected();
        
        if(this_component.loader && ('current' in this_component.loader) && this_component.loader.current!=null) this_component.loader.current.hideLoader();
    }
    
    async componentDidMount()
    {
        var this_component = this;
        
        if(this_component.props.loadData === true)
        {
            this_component.loadData();
        }
    }
    
    async componentDidUpdate(prevProps)
    {
        var this_component = this;
        
        if(this_component.loader && ('current' in this_component.loader) && this_component.loader.current!=null) this_component.loader.current.showLoader();
        
        if( ('shares' in prevProps) && ('shares' in this_component.props) && (JSON.stringify(prevProps.shares)!=JSON.stringify(this_component.props.shares)) )
        {
            //console.log('componentDidUpdate', JSON.parse(JSON.stringify(prevProps)), JSON.parse(JSON.stringify(this_component.props)) );
            await this_component.promisedSetState( {'shares': {...this_component.props.shares} } );
            await this_component.updateSelected();
        }
        
        
        if(this_component.loader && ('current' in this_component.loader) && this_component.loader.current!=null) this_component.loader.current.hideLoader();
    }
    
    render()
    {
        var this_component = this;
        
        return (
            <Loader ref={this_component.loader}>
                
                <Notification backgroundColor="var(--primary-selected-color)">
                    <Info style={{ 'verticalAlign': 'top' }} /> All data sources are shared with users with administrator permissions by default.
                </Notification>
                
                <div className="form-group mb-2">
                    <label className={""+this_component.props.labelsBold} style={{'color':'var(--primary-text-color)'}}>Users</label>
                    <Dropdown menuPosition={(this_component.props.fixed?Dropdown.menuPositions.FIXED:null)} value={[]} options={this_component.state.user_options} value={this_component.state.user_selected} multi multiline onChange={ (selected) => this_component.handleChangeUser(selected) } />
                    <div className="form-text text-muted">Select users by name</div>
                </div>
                <div className="form-group mb-2">
                    <label className={""+this_component.props.labelsBold} style={{'color':'var(--primary-text-color)'}}>Teams</label>
                    <Dropdown menuPosition={(this_component.props.fixed?Dropdown.menuPositions.FIXED:null)} value={[]} options={this_component.state.team_options} value={this_component.state.team_selected} multi multiline onChange={ (selected) => this_component.handleChangeTeam(selected) } />
                    <div className="form-text text-muted">Select teams by name</div>
                </div>
            </Loader>
        );
    }
}

Share.propTypes = {
    'shares': PropTypes.object,
    'onChange': PropTypes.func,
    'fixed': PropTypes.bool,
    'loadData': PropTypes.bool
};

Share.defaultProps = {
    'shares': {},
    'onUpdate': undefined,
    'fixed': true,
    'loadData': true,
    'labelsBold': 'textBold'
};

export default Share;
